<template>
    <h4 style="margin: 5px">{{ $t('common_update_item') }}</h4>
    <div class="row" v-for="(value, key, index) in popUpReturnData" style="margin: 5px">
        <div class="col-4">
            <label class="col-form-label">{{ key }}</label>
        </div>
        <div class="col-8">
            <input class="form-control"
                   v-model="popUpReturnData[key]"
                   :disabled="index===0"
                   v-if="index !== popUpRowHeaders.length-1">

            <select v-model="popUpReturnData[key]"
                    v-if="index === popUpRowHeaders.length-1"
                    class="form-select">
                <option value="1">{{ $t('common_show') }}</option>
                <option value="0">{{ $t('common_hide') }}</option>
            </select>
        </div>
    </div>
    <button class="btn btn-primary"
            style="margin: 5px auto 10px auto;width: 200px"
            @click="uploadData">
        {{ $t('common_save') }}
    </button>
    <br>
    <button class="btn btn-danger"
            v-if="mode !== 'add' && permissionToDelete === true"
            style="margin: 5px auto 10px auto;width: 200px"
            @click="deleteData">
        {{ $t('common_delete') }}
    </button>

    <div v-if="isError">
        <p class="error-text">{{ errorMessage }}</p>
        <div v-for="(value, key) in errorDetails">
            <div class="row" style="border: #2c3e50 1px solid">
                <div class="col-4"><p>{{ key }}</p></div>
                <div class="col-8">
                    <p v-for="(v, k) in value">
                        <span><strong>{{ k }}</strong></span> : <span class="error-text">{{ v }}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "OtherDetailsEditPopUp",
    props: {
        mode: '',
        popUpType: '',
        popUpRowHeaders: '',
        popUpReturnData: '',
        permissionToDelete: '',
    },
    data(){
        return{
            errorMessage: '',
            errorDetails: '',
            isError: false,
        }
    },
    watch: {
        'popUpReturnData': {
            async handler(newType) {
                if(this.popUpReturnData.hasOwnProperty("ordering_lv")){
                    if(this.popUpReturnData.ordering_lv){
                        // pass, use back its own ordering level
                    }else{
                        this.popUpReturnData.ordering_lv = 99
                    }
                }
                this.clearErrors()
            },
        }
    },
    methods:{
        clearErrors(){
            this.isError = false
            this.errorMessage = ''
            this.errorDetails = ''
        },
        async deleteData(){
            this.$swal.fire({
                title: this.$t('error_warning'),
                text: this.$t('common_confirm_action_delete')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$store.commit('setIsTopLoading', true)
                    this.clearErrors()
                    await this.$mainApi.delete(`api/other-details/single-processor?type=${this.popUpType}&id=${this.popUpReturnData.id}`)
                        .then(response => {
                            if(response.data.status === 80){
                                this.$toast.success(this.$t('common_success'))
                                this.$emit('reloadNow', this.popUpType)
                            }else{
                                this.errorMessage = response.data.errors
                                this.errorDetails = response.data.details
                                this.isError = true
                            }
                        })
                    this.$store.commit('setIsTopLoading', false)
                }
            })
        },
        async uploadData(){
            this.$store.commit('setIsTopLoading', true)
            this.clearErrors()
            if(this.mode === "add"){
                this.popUpReturnData.id = null
            }
            await this.$mainApi.put('api/other-details/single-processor/', {
                "type": this.popUpType,
                "returnData": this.popUpReturnData
            })
                .then(response => {
                    if(response.data.status === 80){
                        this.$toast.success(this.$t('common_success'))
                        this.$emit('reloadNow', this.popUpType)
                    }else{
                        this.errorMessage = response.data.errors
                        this.errorDetails = response.data.details
                        this.isError = true
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        }
    }
}
</script>

<style scoped>

</style>
